import { API } from "api";

export const getAllProductFormatAPI = () => {
    return API.get("/api/productformat/getall?page=0&size=0")
                .then((res) => res);
};

export const createProductFormatAPI = (payload) => {
    return API.post("/api/productformat/add", payload)
                .then((res) => res);
}

export const updateProductFormatAPI = (id, payload) => {
    return API.put(`/api/productformat/update/${id}`, payload)
                .then((res) => res);
}

export const deleteProductFormatAPI = (id) => {
    return API.delete(`/api/productformat/delete/${id}`)
                .then((res) => res);
}
export const getAllActiveAreaAPI = () => {
    return API.get("/api/area/getallactive?page=0&size=0")
                .then((res) => res);
}
export const getAllProductFormatTypeAPI = () => {
    return API.get("/api/productformattype/getall?page=0&size=0")
                .then((res) => res);
}